// extracted by mini-css-extract-plugin
export default {"cartButton":"style_cartButton__+ENK9","quantity":"style_quantity__ZzhjD"};